module.exports = __webpack_public_path__ + "static/media/underline.762a912b.svg";